// extracted by mini-css-extract-plugin
export default {"general-warning":"style_general-warning__6rjX4","generalWarning":"style_general-warning__6rjX4"};